import React from 'react';

const Error = () => (
    <div className="text-center py-5 mt-5">
        <p className="pt-1">Ruh roh. Something has gone wrong here.</p>
    </div>
);

export default Error;